export const SAVE_MISSION_ADDING_BENEFICIARY = "SAVE_MISSION_ADDING_BENEFICIARY"

export const RESET_MISSION_ADDING_BENEFICIARY = "RESET_MISSION_ADDING_BENEFICIARY"
